import React, { Fragment } from "react";

import moment from "moment";
import { FileLoader } from "@loanbossinc/component-library";
import { StandAloneAttachmentsItem } from "./StandAloneAttachmentsItem";
import { downloadFile } from "utils/api";
import { Grid, Paper, Fade, LinearProgress, Collapse } from "@material-ui/core";
import {
  PaddedWrapper,
  EmptyAttachmentWrapper,
  NoAttachmentsTextWrapper,
  ImageContainer,
  AttachmentHeader,
  Title,
  StyledInfo
} from "./StandAloneAttachmentsStyles";

const paperclip = `/images/Paperclip.png`;

export class StandAloneAttachments extends React.Component {
  handleDownload = fileId => downloadFile(`files/${fileId}`);

  handleUpload = files => this.props.onAdd(files[0]);

  isLast = (index, fileCount) => {
    return index === fileCount - 1;
  };

  createAttachment = (file, index, fileCount) => {
    const { authentication } = this.props;
    const isLast = this.isLast(index, fileCount);

    return (
      <Fragment key={index}>
        <StandAloneAttachmentsItem
          file={file}
          authentication={authentication}
          onRemove={this.props.onRemove}
          onUpdate={this.props.onUpdate}
          onDownload={() => this.handleDownload(file.id)}
        />
      </Fragment>
    );
  };

  emptyAttachmentContainer = () => {
    return (
      <>
        <EmptyAttachmentWrapper>
          <ImageContainer>
            <img src={paperclip} />
          </ImageContainer>
        </EmptyAttachmentWrapper>
        <br />
        <NoAttachmentsTextWrapper>No attachments for this deal</NoAttachmentsTextWrapper>
      </>
    );
  };

  render() {
    const { files, isLoading } = this.props;
    return (
      <Fragment>
        <PaddedWrapper>
          <AttachmentHeader>
            <Grid container>
              <Grid item xs={12}>
                <Title>Attachments</Title>
              </Grid>
              <Grid item xs={10}>
                <StyledInfo>{`Attachments are only accessible to users within your`}</StyledInfo>
                <StyledInfo>{`company unless you make them public after uploading.`}</StyledInfo>
              </Grid>
            </Grid>
          </AttachmentHeader>

          <div className="file-loader">
            <Collapse in={!isLoading} timeout={300}>
              <Paper elevation={1}>
                <FileLoader multiple={false} onDrop={this.handleUpload} style={{ width: "100%" }} />
              </Paper>
            </Collapse>
            <Fade in={isLoading} timeout={300}>
              <Paper elevation={1}>
                <LinearProgress />
              </Paper>
            </Fade>
          </div>

          {files && files.length > 0 && (
            <Grid container direction="column" id="notesList">
              {files.sort((a, b) => moment.utc(b.createdAt).unix() - moment.utc(a.createdAt).unix()).map((x, i) => this.createAttachment(x, i, files.length))}
            </Grid>
          )}

          {files && files.length === 0 && (
            <Grid container direction="column" id="notesList" alignItems={"center"}>
              {this.emptyAttachmentContainer()}
            </Grid>
          )}
        </PaddedWrapper>
      </Fragment>
    );
  }
}
